import React from 'react'
import { StyleSheet, View, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { IconName, Icon, Text } from '../atoms'
import { useScreen } from '@hooks'
import { useLanguage } from '@context'

export type FilterHeaderProps = {
  title?: string
  iconLeft?: IconName
  iconColor?: string
  onPressLeft?: () => void
  filterCount?: number
  onClearFilters?: () => void
}

export const FilterHeader = ({
  title,
  iconLeft,
  iconColor,
  onPressLeft,
  filterCount = 0,
  onClearFilters,
}: FilterHeaderProps): React.ReactElement => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)
  const {isMobile} = useScreen()

  const showClearButton = filterCount > 0 && onClearFilters

  return (
    <View style={[styles.container, !isMobile && styles.containerNonMobile]}>
      {iconLeft && (
        <Icon name={iconLeft} onPress={onPressLeft} color={iconColor || theme.colors.primary} />
      )}

      <View style={styles.titleContainer}>
        <Text type="titleBold" style={styles.title}>
          {title}
        </Text>
        {isMobile && filterCount > 0 && (
          <View style={styles.countContainer}>
            <Text type="bodySmall" style={styles.countText}>
              {filterCount}
            </Text>
          </View>
        )}
      </View>

      {showClearButton ? (
        <TouchableOpacity onPress={onClearFilters} style={styles.clearButton}>
          <Text type="bodySmall" style={styles.clearText}>
            {t('swipeable.delete')}
          </Text>
        </TouchableOpacity>
      ) : (
        <View style={styles.iconPlaceholder} />
      )}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: theme.spacing.xl,
      paddingVertical: theme.spacing.md,
    },
    containerNonMobile: {
      backgroundColor: theme.colors.sidebar,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.lightGrey,
    },
    titleContainer: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    title: {
      textAlign: 'center',
      marginLeft: theme.spacing.sm,
    },
    countContainer: {
      backgroundColor: theme.colors.primary,
      borderRadius: 10,
      minWidth: 20,
      height: 20,
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: theme.spacing.sm,
    },
    countText: {
      color: theme.colors.white,
      fontWeight: 'bold',
      fontSize: 11,
    },
    clearButton: {
      borderBottomWidth: 1,
      borderColor: theme.colors.primary,
    },
    clearText: {
      color: theme.colors.primary,
      fontWeight: '500',
    },
    iconPlaceholder: {
      width: 50,
    },
  })
